// clear all empty properties and event result is it is empty
export default function omitEmpty(jsonData: any) {
    const result = _.omitBy(jsonData, property => _.isEmpty(property))
    return !_.isEmpty(result) ? result : undefined
}
